import React from "react";
import { ToggleButtonGroup, ToggleButton, Tooltip, useTheme } from "@mui/material";
import {
  GridView,
  ViewStream,
  TableChart,
} from "@mui/icons-material";
import { VIEW_MODES } from "../../hooks/useViewPreference";

const viewOptions = [
  {
    value: VIEW_MODES.CARD,
    icon: GridView,
    label: "Card Grid",
    description: "View apps as cards in a grid",
  },
  {
    value: VIEW_MODES.ACTIVITY,
    icon: ViewStream,
    label: "Activity",
    description: "View apps grouped by status",
  },
  {
    value: VIEW_MODES.TABLE,
    icon: TableChart,
    label: "Table",
    description: "View apps in a table",
  },
];

/**
 * View mode toggle component
 */
export function ViewToggle({ value, onChange }) {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  const handleChange = (event, newValue) => {
    if (newValue !== null) {
      onChange(newValue);
    }
  };

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={handleChange}
      aria-label="view mode"
      size="small"
      sx={{
        background: isDarkMode ? "#1e293b" : "#f1f5f9",
        borderRadius: "10px",
        padding: "4px",
        border: "none",
        "& .MuiToggleButtonGroup-grouped": {
          border: "none",
          borderRadius: "8px !important",
          mx: 0.25,
          "&:not(:first-of-type)": {
            borderRadius: "8px !important",
          },
          "&:first-of-type": {
            borderRadius: "8px !important",
          },
        },
        "& .MuiToggleButton-root": {
          px: 1.5,
          py: 0.75,
          textTransform: "none",
          fontWeight: 500,
          fontSize: "0.8rem",
          color: isDarkMode ? "#94a3b8" : "#64748b",
          gap: 0.75,
          transition: "all 0.2s ease",
          "&:hover": {
            background: isDarkMode ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.03)",
          },
          "&.Mui-selected": {
            background: "#F97316",
            color: "#fff",
            "&:hover": {
              background: "#EA580C",
            },
          },
        },
      }}
    >
      {viewOptions.map((option) => {
        const Icon = option.icon;
        return (
          <Tooltip key={option.value} title={option.description} arrow>
            <ToggleButton value={option.value} aria-label={option.label}>
              <Icon sx={{ fontSize: "1.1rem" }} />
              {option.label}
            </ToggleButton>
          </Tooltip>
        );
      })}
    </ToggleButtonGroup>
  );
}

export default ViewToggle;
